import './utilities/polyfills'
import 'normalize.css'
import 'react-mdl/extra/material.css'
import 'react-mdl/extra/material.js'
import React from 'react'
import { browserHistory, Router, } from 'react-router'
import { Provider, } from 'react-redux'
import { render, } from 'react-dom'
import { syncHistoryWithStore, } from 'react-router-redux'
import './index.css'
import actions from 'actions'
import config from './config'
import facebookService from 'infrastructure/FacebookService'
import firebase from 'firebase'
import firebaseService from 'infrastructure/FirebaseService'
import heapService from 'infrastructure/HeapService'
import injectTapEventPlugin from 'react-tap-event-plugin'
import jss from 'jss'
import preset from 'jss-preset-default'
import Raven from 'raven-js'
import Routes from './Routes'
import store from 'store'

const firebaseConfig = {
  apiKey: config.API_KEY,
  authDomain: config.PROJECT_ID + '.firebaseapp.com',
  databaseURL: 'https://' + config.PROJECT_ID + '.firebaseio.com',
  storageBucket: config.PROJECT_ID_FOR_BUCKET + '.appspot.com',
}
const history = syncHistoryWithStore(browserHistory, store)

firebase.initializeApp(firebaseConfig)
firebaseService.initialize(firebase)
jss.setup(preset())

function initApp() {
  // use the startListeningToAuth action directly when not restricting emails via whitelist
  // store.dispatch(actions.startListeningToAuth())
  // use the action below if users need to be whitelisted by email
  // and usernames must be unique

  if (config.HEAP_API_KEY) {
    heapService.initialize()
    Raven.config(config.SENTRY_API_KEY).install()
    facebookService.initialize()
  }

  store.dispatch(actions.startListeningToFirebase())
  document.getElementById('progress-bar').style.display = 'none'
}

window.onload = function () {
  initApp()
}
window.onunload = function () {
  window.heap.track('Page Unload')
}

injectTapEventPlugin()

Raven.context(function () {
  render(
    <Provider store={store}>
      <Router onUpdate={() => window.scrollTo(0, 0)} history={history}>
        {Routes}
      </Router>
    </Provider>,
    document.getElementById('app')
  )
})



// WEBPACK FOOTER //
// ./src/app/app.js